import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OrgTreeActionsDirective } from '../directives/org-tree-actions.directive';
import { OrgTreeService } from '../services/org-tree.service';
import { OrgReportingComponent } from '../org-reporting/org-reporting.component';
import { GuardService } from '../../../shared/services/guard.service';
import { OrgMassUnpublishComponent } from '../org-mass-unpublish/org-mass-unpublish.component';
import { OrgCommunicationSettingsComponent } from '../org-communication-settings/org-communication-settings.component';
import { ModuleService } from '../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../current-project';
import { environment } from '../../../../environments/default/environment';
import { OrgSettingsComponent } from '../org-settings/org-settings.component';

@Component({
    selector: 'app-org-header',
    templateUrl: './org-header.component.html',
    styleUrls: ['./org-header.component.scss'],
    standalone: false
})
export class OrgHeaderComponent extends OrgTreeActionsDirective {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    isDev = !environment.production;
    form: UntypedFormGroup;
    description: string;

    get windowWidth(): number {
        return window.innerWidth;
    }

    protected get isDeactivated(): boolean {
        return this.rootNode?.deactivated ?? false;
    }

    constructor(
        private dialog: MatDialog,
        private guardService: GuardService,
        orgTreeService: OrgTreeService,
        moduleService: ModuleService
    ) {
        super(orgTreeService, moduleService);
    }

    protected isAdmin(): boolean {
        return this.guardService.isAdmin;
    }

    protected openDialogSettings(): void {
        this.dialog.open(OrgSettingsComponent, {
            panelClass: 'custom-dialog'
        });
    }

    protected openDialogCommunication(): void {
        this.dialog.open(OrgCommunicationSettingsComponent, {
            panelClass: 'custom-dialog',
            position: { top: '250px' }
        });
    }

    protected openReporting(): void {
        this.dialog
            .open(OrgReportingComponent, {
                position: { top: '50px' },
                panelClass: 'custom-dialog',
                data: {
                    query: {
                        orgCode: this.orgCode ?? null,
                        responsibleType: this.responsibleType && this.guardService.isAdmin ? this.responsibleType : null
                    },
                    multiple: true
                }
            })
            .afterClosed()
            .subscribe((e: string[]) => e?.length && this.reloadOrgTree(e));
    }

    protected openUnPublish(): void {
        this.dialog
            .open(OrgMassUnpublishComponent, {
                position: { top: '50px' },
                panelClass: 'custom-dialog',
                data: {
                    query: {
                        orgCode: this.orgCode ?? null,
                        responsibleType: this.responsibleType && this.guardService.isAdmin ? this.responsibleType : null
                    },
                    multiple: true
                }
            })
            .afterClosed()
            .subscribe((e: string[]) => e?.length && this.reloadOrgTree(e));
    }
}
